import React, {useMemo} from "react";
import {DayPicker} from "react-day-picker";
import {ptBR} from "react-day-picker/locale";
import "react-day-picker/dist/style.css";
import {AgGridReact} from "ag-grid-react";
import {FaTrash} from "react-icons/fa";
import {Card} from "../../../../../components/card/card.jsx";
import Button from "../../../../../components/button/button.jsx";
import InputDatetime from "../../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import SentryRow from "../../../../../components/template/sentry-row.jsx";
import aggridUtils from "../../../../../utils/aggrid-utils.js";
import {DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL} from "../../../../../utils/ag-grid-columns-utils.js";

const REQUIRED_BG = "!bg-[#fdfdee]";
const REQUIRED_LABEl_BG = "!bg-[linear-gradient(to_bottom,transparent_50%,#fdfdee_50%)]";

const ScheduleAttendanceScheduleCard = ({
    scheduleMode,
    onScheduleModeChange,
    selectedDates,
    onSelectedDatesChange,
    dateHour,
    onDateHourChange,
    dateList,
    onRemoveDate,
    onAddSelectedDates,
    recurrence,
    onChangeRecurrence,
    weekdayOptions,
}) => {
    const dateColumnDefs = useMemo(() => [
        {field: "date", headerName: "Agendamento", flex: 1, comparator: aggridUtils.agGridCompareDateTime },
        {
            headerName: "",
            width: 50,
            sortable: false,
            cellRenderer: ({data}) => (
                <div className="w-full h-full flex items-center justify-center">
                    <Button
                        className="h-6.5! w-6.5! p-0!"
                        target="danger"
                        title="Remover"
                        onClick={(event) => {
                            event.stopPropagation();
                            onRemoveDate(data.date);
                        }}
                    >
                        <FaTrash/>
                    </Button>
                </div>
            ),
        },
    ], [onRemoveDate]);

    return (
        <Card>
            <Card.Header>
                <Card.Title>Agendamento</Card.Title>
            </Card.Header>
            <Card.Body className="flex flex-col gap-4">
                <div className="flex gap-8">
                    <label className="flex items-center gap-2 text-sm text-gray-500 cursor-pointer">
                        <input type="radio" checked={scheduleMode === "LIST"} onChange={() => onScheduleModeChange("LIST")}/>
                        Datas
                    </label>
                    <label className="flex items-center gap-2 text-sm text-gray-500 cursor-pointer">
                        <input type="radio" checked={scheduleMode === "RECURRENCE"} onChange={() => onScheduleModeChange("RECURRENCE")}/>
                        Recorrentes
                    </label>
                </div>

                {scheduleMode === "LIST" &&
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-7 flex gap-4">
                            <div>
                                <div className="border border-gray-200 rounded-md inline-block" id="day-picker-attendance">
                                    <DayPicker
                                        className="w-full"
                                        mode="multiple"
                                        locale={ptBR}
                                        selected={selectedDates}
                                        onSelect={(value) => onSelectedDatesChange(value ?? [])}
                                        showOutsideDays
                                    />
                                </div>
                                <div className="flex gap-2 mt-3">
                                    <InputDatetime
                                        classNameWrapper="w-full"
                                        inputClass={REQUIRED_BG}
                                        labelClass={REQUIRED_LABEl_BG}
                                        id="hour"
                                        label="Horário *"
                                        dateFormat="LT"
                                        returnDateObj={false}
                                        selected={dateHour}
                                        onChange={(value) => onDateHourChange(value ?? "")}
                                    />
                                    <Button onClick={onAddSelectedDates}>Adicionar</Button>
                                </div>
                            </div>
                            <div className="w-full">
                                <AgGridReact
                                    rowData={dateList}
                                    columnDefs={dateColumnDefs}
                                    defaultColDef={DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL}
                                    animateRows={false}
                                    suppressCellFocus={true}
                                    gridOptions={{localeText: aggridUtils.localization()}}
                                    theme={aggridUtils.generalTheme()}
                                />
                            </div>
                        </div>
                    </div>
                }

                {scheduleMode === "RECURRENCE" &&
                    <SentryRow>
                        <InputDatetime
                            classNameWrapper="col-span-2"
                            inputClass={REQUIRED_BG}
                            labelClass={REQUIRED_LABEl_BG}
                            id="dateStart"
                            label="Data inicial *"
                            dateFormat="L"
                            returnDateObj={false}
                            selected={recurrence.dateStart}
                            onChange={(value) => onChangeRecurrence("dateStart", value ?? "")}
                        />
                        <InputDatetime
                            classNameWrapper="col-span-2"
                            id="dateEnd"
                            label="Data final"
                            dateFormat="L"
                            returnDateObj={false}
                            selected={recurrence.dateEnd}
                            onChange={(value) => onChangeRecurrence("dateEnd", value ?? "")}
                        />
                        <InputDatetime
                            classNameWrapper="col-span-2"
                            inputClass={REQUIRED_BG}
                            labelClass={REQUIRED_LABEl_BG}
                            id="startHour"
                            label="Horário *"
                            dateFormat="LT"
                            returnDateObj={false}
                            selected={recurrence.startHour}
                            onChange={(value) => onChangeRecurrence("startHour", value ?? "")}
                        />
                        <SelectComponent
                            classNameWrapper="col-span-6"
                            id="schedule-week-days"
                            label="Dias da semana *"
                            isMulti
                            options={weekdayOptions}
                            value={recurrence.weekdays}
                            onChange={(options) => onChangeRecurrence("weekdays", options ?? [])}
                        />
                    </SentryRow>
                }
            </Card.Body>
        </Card>
    );
};

export default ScheduleAttendanceScheduleCard;
